import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { LogoMark } from "@/components/Logo";
import { FadeIn } from "@/components/Motion";

export default function NotFound() {
  return (
    <section
      className="relative flex min-h-[100svh] items-center justify-center overflow-hidden bg-navy-deep px-6"
      data-testid="not-found-page"
    >
      <div className="grain absolute inset-0" aria-hidden="true" />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(196,164,106,0.08),transparent_55%)]"
      />
      <div className="relative max-w-xl text-center">
        <FadeIn y={20}>
          <LogoMark className="mx-auto h-14 w-auto" />
          <p className="mt-10 font-serif text-7xl font-semibold text-gold sm:text-8xl">
            404
          </p>
          <h1 className="mt-6 font-serif text-3xl font-medium text-white sm:text-4xl">
            This page could not be found.
          </h1>
          <p className="mt-5 text-base leading-relaxed text-white/60">
            The page you are looking for may have been moved, renamed, or never
            existed. Let us guide you back.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <Link to="/" data-testid="notfound-cta-home" className="btn-gold">
              Return Home
            </Link>
            <Link to="/contact" data-testid="notfound-cta-contact" className="btn-outline-light">
              Contact Us
            </Link>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}
